import { useSelector } from 'react-redux';
import { RootState } from 'store';

export function useGetSoftPhoneAuthStatus() {
  const isAuthenticatedSoftPhone = useSelector((state: RootState) => state.authSoftPhone.isAuthenticated);
  const softPhoneToken = useSelector((state: RootState) => state.authSoftPhone.softPhoneToken);

  return { softPhoneToken, isAuthenticatedSoftPhone };
}